var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible,"title":"商品详情","top":"5vh","width":"1200"},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',[_c('WmsTable',{staticStyle:{"height":"700px"},attrs:{"columns":_vm.columns,"isPagination":false,"hasHeader":false,"dataSource":_vm.data,"rowKey":"pkgCode","scrollY":650}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }